import React from 'react'
import Input from 'components/Form/Input'
import Select from 'components/Select'

import {
  SectionHeading,
  StyledInputDiv,
  StyledInput,
  ExtraWidth
} from 'modules/Students/Partials/AddNewStudentDrawer/Style/style'
import Label from 'components/Form/Label'
import { IsValidEmail } from 'utils/emailValidation'

const ContactDetails = ({ countryCode, setCountryCode }) => {
  const onCountryCodeChange = (id, value) => {
    setCountryCode(value?.option?.value)
  }
  const CountryCode = [
    {
      id: '1',
      value: '+91',
    },
    {
      id: '2',
      value: '+93',
    },
    {
      id: '3',
      value: '+92',
    },
  ]
  return (
    <>
      <SectionHeading>Contact Details</SectionHeading>

      <Input
        width="100%"
        label="Email ID"
        placeholder="Eg. example@gmail.com"
        optional={'*'}
        name={'email'}
        rules={[
          () => ({
            validator(_, value) {
              let isValid = IsValidEmail(value);
              if (!isValid) {

               
              
                return Promise.reject(
                  new Error(`Please Enter Valid Email`)
                );
              
              }

              return Promise.resolve();
            },
          }),
        ]}
      />

      <Label required={true}>
        Phone Number <span>*</span>
      </Label>

      <StyledInputDiv>
        <ExtraWidth>
        <Select
          OptionData={CountryCode}
          nameParam="value"
          bordered={false}
          onChange={onCountryCodeChange}
          value={countryCode}
        />
        </ExtraWidth>
       
        <StyledInput
          width="100%"
          type="number"
          onWheel={(e) => e.target.blur()}
          name={'contactNumber'}
          placeholder="Eg: 1010101010"
          rules={[
            {
              required: true,
              message: 'Please Enter phone number!',
            },
            {
              min:10,
              max:10,
              message: 'Please enter valid phone number',
            },
          ]}
        />
      </StyledInputDiv>
    </>
  )
}

export default ContactDetails
